export interface RecruiterActivityRequestModel {
    eventType: CandidateProfileEventType;
    talentId: string;
}
export enum CandidateProfileEventType {
  CandidateProfileOpened = "candidate_profile_opened",
  CandidateMatchProfileOpened = "candidate_match_profile_opened",
  CandidateMatchDetailsOpened = "candidate_match_details_opened",
  CandidateCvDownloaded = "candidate_cv_downloaded",
  CandidatePhoneClicked = "candidate_phone_clicked",
  CandidateLinkedinClicked = "candidate_linkedin_clicked",
  CandidateGithubClicked = "candidate_github_clicked",
  CandidatePortfolioClicked = "candidate_portfolio_clicked",
  CandidateWebsiteClicked = "candidate_website_clicked",
  CandidateTelegramClicked = "candidate_telegram_clicked",
  CandidateTwitterClicked = "candidate_twitter_clicked",
  CandidateYoutubeClicked = "candidate_youtube_clicked",
  CandidateDribbleClicked = "candidate_dribble_clicked",
  CandidateStackoverflowClicked = "candidate_stackoverflow_clicked",
  CandidateExternalLinkClicked = "candidate_external_link_clicked",
}

export const IMMEDIATE_FLUSH_EVENTS = new Set([
  CandidateProfileEventType.CandidateProfileOpened,
  CandidateProfileEventType.CandidateMatchProfileOpened,
  CandidateProfileEventType.CandidateMatchDetailsOpened,
  CandidateProfileEventType.CandidateCvDownloaded,
  CandidateProfileEventType.CandidatePhoneClicked,
  CandidateProfileEventType.CandidateLinkedinClicked,
  CandidateProfileEventType.CandidateGithubClicked,
  CandidateProfileEventType.CandidatePortfolioClicked,
  CandidateProfileEventType.CandidateWebsiteClicked,
  CandidateProfileEventType.CandidateTelegramClicked,
  CandidateProfileEventType.CandidateTwitterClicked,
  CandidateProfileEventType.CandidateYoutubeClicked,
  CandidateProfileEventType.CandidateDribbleClicked,
  CandidateProfileEventType.CandidateStackoverflowClicked,
  CandidateProfileEventType.CandidateExternalLinkClicked
]);